export default "__VITE_ASSET__CQTPFdJW__"